/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RequestSaleCreateOneSale
 */
export interface RequestSaleCreateOneSale {
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  shopPaymentPointId: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  countItems: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  priceItems: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  priceItemsBuy: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  priceItemsDiscount: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  priceDiscount: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  sumRaise: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  priceFinal: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  sumGive: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneSale
   */
  sumBack: string
  /**
   *
   * @type {number}
   * @memberof RequestSaleCreateOneSale
   */
  dateOperation: number
}

/**
 * Check if a given object implements the RequestSaleCreateOneSale interface.
 */
export function instanceOfRequestSaleCreateOneSale(
  value: object,
): value is RequestSaleCreateOneSale {
  if (
    !('shopPaymentPointId' in value) ||
    value['shopPaymentPointId'] === undefined
  )
    return false
  if (!('countItems' in value) || value['countItems'] === undefined)
    return false
  if (!('priceItems' in value) || value['priceItems'] === undefined)
    return false
  if (!('priceItemsBuy' in value) || value['priceItemsBuy'] === undefined)
    return false
  if (
    !('priceItemsDiscount' in value) ||
    value['priceItemsDiscount'] === undefined
  )
    return false
  if (!('priceDiscount' in value) || value['priceDiscount'] === undefined)
    return false
  if (!('sumRaise' in value) || value['sumRaise'] === undefined) return false
  if (!('priceFinal' in value) || value['priceFinal'] === undefined)
    return false
  if (!('sumGive' in value) || value['sumGive'] === undefined) return false
  if (!('sumBack' in value) || value['sumBack'] === undefined) return false
  if (!('dateOperation' in value) || value['dateOperation'] === undefined)
    return false
  return true
}

export function RequestSaleCreateOneSaleFromJSON(
  json: any,
): RequestSaleCreateOneSale {
  return RequestSaleCreateOneSaleFromJSONTyped(json, false)
}

export function RequestSaleCreateOneSaleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestSaleCreateOneSale {
  if (json == null) {
    return json
  }
  return {
    shopPaymentPointId: json['shopPaymentPointId'],
    countItems: json['countItems'],
    priceItems: json['priceItems'],
    priceItemsBuy: json['priceItemsBuy'],
    priceItemsDiscount: json['priceItemsDiscount'],
    priceDiscount: json['priceDiscount'],
    sumRaise: json['sumRaise'],
    priceFinal: json['priceFinal'],
    sumGive: json['sumGive'],
    sumBack: json['sumBack'],
    dateOperation: json['dateOperation'],
  }
}

export function RequestSaleCreateOneSaleToJSON(
  json: any,
): RequestSaleCreateOneSale {
  return RequestSaleCreateOneSaleToJSONTyped(json, false)
}

export function RequestSaleCreateOneSaleToJSONTyped(
  value?: RequestSaleCreateOneSale | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    shopPaymentPointId: value['shopPaymentPointId'],
    countItems: value['countItems'],
    priceItems: value['priceItems'],
    priceItemsBuy: value['priceItemsBuy'],
    priceItemsDiscount: value['priceItemsDiscount'],
    priceDiscount: value['priceDiscount'],
    sumRaise: value['sumRaise'],
    priceFinal: value['priceFinal'],
    sumGive: value['sumGive'],
    sumBack: value['sumBack'],
    dateOperation: value['dateOperation'],
  }
}
